import * as React from "react";
import { BooleanInput as BooleanInputAtom } from "../../atoms/forms/BooleanInput";
import { ICommonInputsControls } from "./ICommonInputsControls";

// All the incoming values
interface IProps {
    trueLabel?: string;
    falseLabel?: string;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControls<boolean>;
export const BooleanInput = (props: AllProps) => {
    return (
        <BooleanInputAtom
            label={props.label || ""}
            value={props.value}
            loading={props.loading}
            disabled={props.disabled}
            required={props.required}
            error={props.error}
            placeholder={props.placeholder}
            prevalidate={props.prevalidate}
            icon={props.icon}
            trueLabel={props.trueLabel}
            falseLabel={props.falseLabel}
            onChange={props.onChange}
            onValidate={props.onValidate}
        />
    );
};


